import { taggedTemplateLiteral as _taggedTemplateLiteral, slicedToArray as _slicedToArray, asyncToGenerator as _asyncToGenerator, regenerator as _regenerator } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React__default, { useState, useEffect } from 'react';
import styled from 'styled-components';
import pathOr from '../../node_modules/ramda/es/pathOr.js';
import Modal from '../../node_modules/reactstrap/esm/Modal.js';
import ModalBody from '../../node_modules/reactstrap/esm/ModalBody.js';
import Theme from '../../Theme/index.js';
import { InfoIcon, SuccessCheckmarkIcon } from '../Icons/index.js';

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;
var TitleBar = styled.header(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  margin: 0 30px;\n  margin-top: 30px;\n"])));
var Title = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  font-family: ", ";\n  font-size: 20px;\n  font-weight: bold;\n  color: ", ";\n"])), Theme.fonts.Montserrat, Theme.colors.primary);
var NarrowModal = styled(Modal)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  max-width: 490px;\n  @media screen and (max-width: 575.98px) {\n    min-width: 0px;\n    width: 95%;\n    margin: 10px;\n  }\n  .modal-content {\n    border-radius: 0;\n    border: none;\n  }\n"])));
var Body = styled(ModalBody)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  padding: 0;\n  margin: 30px;\n"])));
var ModalLoaderText = styled.h6(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  text-align: center;\n"])));
var sleep = function sleep(ms) {
  return new Promise(function (resolve, _reject) {
    return setTimeout(resolve, ms);
  });
};
var isComplete = function isComplete(status) {
  return status.includes("Completed");
};
var ModalCompleteDefault = function ModalCompleteDefault(_ref) {
  var ModalBodyChild = _ref.ModalBodyChild;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "d-flex flex-column align-items-center"
  }, /*#__PURE__*/React__default.createElement(SuccessCheckmarkIcon, null), /*#__PURE__*/React__default.createElement(ModalLoaderText, {
    className: "mt-4 mb-1"
  }, "Process successfully complete!"), ModalBodyChild && /*#__PURE__*/React__default.createElement(ModalBodyChild, null));
};
var ModalBodyLoader = function ModalBodyLoader(_ref2) {
  var widStatusQuery = _ref2.widStatusQuery,
    wid = _ref2.wid,
    ModalBodyComp = _ref2.ModalBodyComp,
    ModalBodyChild = _ref2.ModalBodyChild;
  var _useState = useState({}),
    _useState2 = _slicedToArray(_useState, 2),
    response = _useState2[0],
    setResponse = _useState2[1];
  useEffect(function () {
    var _pingStatus = /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var response, widStatus;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              if (typeof widStatusQuery === "function") {
                _context.n = 1;
                break;
              }
              return _context.a(2);
            case 1:
              _context.n = 2;
              return widStatusQuery(wid);
            case 2:
              response = _context.v;
              setResponse(response);
              widStatus = pathOr("", ["data", "widStatus"], response);
              if (isComplete(widStatus)) {
                _context.n = 4;
                break;
              }
              _context.n = 3;
              return sleep(1000);
            case 3:
              return _context.a(2, _pingStatus());
            case 4:
              return _context.a(2);
          }
        }, _callee);
      }));
      return function pingStatus() {
        return _ref3.apply(this, arguments);
      };
    }();
    _pingStatus();
  }, [wid, widStatusQuery]);
  var _ref4 = response || {},
    loading = _ref4.loading,
    error = _ref4.error,
    data = _ref4.data;
  if (loading) return /*#__PURE__*/React__default.createElement(ModalLoaderText, null, "Loading...");
  if (error) return /*#__PURE__*/React__default.createElement(ModalLoaderText, null, "There was an Error with the request.");
  var widStatus = pathOr("", ["widStatus"], data);
  return isComplete(widStatus) ? ModalBodyComp ? /*#__PURE__*/React__default.createElement(ModalBodyComp, null) : /*#__PURE__*/React__default.createElement(ModalCompleteDefault, {
    ModalBodyChild: ModalBodyChild
  }) : /*#__PURE__*/React__default.createElement(ModalLoaderText, null, "Loading...");
};
var hasWidValue = function hasWidValue(wid) {
  return !!wid;
};
var WidModal = function WidModal(_ref5) {
  var wid = _ref5.wid,
    widStatusQuery = _ref5.widStatusQuery,
    ModalBodyComp = _ref5.ModalBodyComp,
    ModalBodyChild = _ref5.ModalBodyChild,
    size = _ref5.size,
    title = _ref5.title;
  return /*#__PURE__*/React__default.createElement(NarrowModal, {
    isOpen: hasWidValue(wid),
    size: size,
    centered: true
  }, /*#__PURE__*/React__default.createElement(TitleBar, null, /*#__PURE__*/React__default.createElement(InfoIcon, null), /*#__PURE__*/React__default.createElement(Title, {
    fontFamily: Theme.fonts.Montserrat
  }, title)), /*#__PURE__*/React__default.createElement(Body, null, /*#__PURE__*/React__default.createElement(ModalBodyLoader, {
    widStatusQuery: widStatusQuery,
    wid: wid,
    ModalBodyComp: ModalBodyComp,
    ModalBodyChild: ModalBodyChild
  })));
};
WidModal.defaultProps = {
  wid: "",
  size: "lg",
  title: "Processing, Please Wait..."
};

export { ModalBodyLoader, ModalCompleteDefault, Title, WidModal as default };
